import React from 'react'

interface Props {
    label?: string
    placeholder?: string
    value?: string
    disabled?: boolean
    onChange: (value: string) => void
}

export const TextArea = ({
    label,
    placeholder,
    disabled,
    onChange,
    value,
}: Props) => {
    return (
        <label className="font-semibold  text-gray-500">
            {label}
            <textarea
                className="w-full font-normal h-32 border border-gray-300 rounded-md p-2 resize-none focus:outline-none"
                placeholder={placeholder}
                disabled={disabled}
                onChange={(e) => onChange(e.target.value)}
                value={value}
            />
        </label>
    )
}
